import { ref, computed } from 'vue';

export function useElementIndex(props) {
  const platformType = ref("web");

  const renderData = ref([]);
  
  const rectBox = reactive({
    width: 10,
    height: 10,
  });

  // 计算属性
  const componentName = computed(() => {
    return firstToUpper1(props.itemData.type);
  });

  const setStyle = computed(() => {
   
 
    return toSetElementStyle(props.itemData.config);
  });

  const currentElementIndexStr = computed(() => {
    return props.currentElementIndex && props.currentElementIndex.length
      ? props.currentElementIndex.join("x")
      : "";
  });

  const itemIdxStr = computed(() => {
    return [...props.parentKeys, props.idx].join("x");
  });

  const isPosition = computed(() => {
    return (
      props.itemData.config.position &&
      props.itemData.config.position !== "static" &&
      !!props.itemData.config.positionVal
    );
  });

  // 方法
  const firstToUpper1 = (str) => {
    return str.trim().replace(str[0], str[0].toUpperCase());
  };

  // 用于发射事件
  const emitAction = (action, idx) => {
    bus.$emit(action, [...props.parentKeys, idx]);
  };

  const selectElement = (idx) => emitAction('selectPcElement', idx);
  const removeElement = (idx) => emitAction('removePcElement', idx);
  const copyElement = (idx) => emitAction('copyPcElement', idx);
  const moveElementUp = (idx) => emitAction('movePcElementUp', idx);
  const moveElementDown = (idx) => emitAction('movePcElementDown', idx);
  const setRenderData = (data) => {
    renderData.value = data;
  };

  return {
    platformType,
    renderData,
    rectBox,
    componentName,
    setStyle,
    currentElementIndexStr,
    itemIdxStr,
    isPosition,
    selectElement,
    removeElement,
    copyElement,
    moveElementUp,
    moveElementDown,
    setRenderData,
  };
}


export function toSetElementStyle(config){
  let setdata = {};
  if ( config &&  config.styles) {
     config.styles
      .replace(/;$/g, "")
      .split(";")
      .map((item) => {
        let [key, val] = item.split(":");
        
        if(!key.match(/\s/g)){  // 空格不添加
          setdata[key] = val;
        }
      });
  }
  return setdata;
}
